module.exports = __webpack_public_path__ + "img/user-2.2a2139d7.svg";